import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Subscribes to the program's channel while an AI draft is running; reloads the
// page when the job broadcasts "refresh".
export default class extends Controller {
  static values = { programId: String }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "ProgramChannel", id: this.programIdValue },
      { received: (data) => { if (data.type === "refresh") window.location.reload() } }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }
}
